export interface IPromotion {
  id: number;
  promo_code: string;
  type: string;
  value: number;
  value_type: string;
  visibility: string;
  active: boolean;
  display_app: boolean;
  expiration_date: string;
  usage_limit: number;
  min_total: number;
  notes: string;
  service_provider_id: number;
  created_at: string;
  deleted_at: string;
  serviceProvider?: any;
}

export const PROMOTION_TYPES = {
  first_order: 'First Order',
  one_time: 'One Time (Any Order)',
  multiple_times: 'Multiple Times (Any Order)',
};

export const PROMOTION_VALUE_TYPES = {
  absolute: 'Absolute (€)',
  percentage: 'Percentage (%)',
};
